export const LocalVideoAction = {
    PLAY: "play",
    PAUSE: "pause",
    SET_USUAL_SPEED: "setUsualSpeed",
    SET_SLOW: "setSlow",
    TICK: "tick",
    SET_TIME_TO_SYNC_START_TIME: "setTimeToSyncStartTime",
    SET_TIME_TO_SYNC_START_TIME_AND_PLAY: "setTimeToSyncStartTimeAndPlay"
} as const
export type LocalVideoActionType = typeof LocalVideoAction[ keyof typeof LocalVideoAction ]

export const VideoSelectAction = {
    SELECT: "select",
    RELEASE: "release",
    SAVE: "save"
} as const
export type VideoSelectActionType = typeof VideoSelectAction[ keyof typeof VideoSelectAction ]


// export const WebViewVideoAction = {
//     VIDEO_LOADED: "videoLoaded",
//     START_SEEK: "startSeek",
//     END_SEEK: "endSeek",
//     DOWNLOAD_VIDEO:"downloadVideo",
// } as const
// export type WebViewVideoActionType = typeof WebViewVideoAction[ keyof typeof WebViewVideoAction ]
